export default "__VITE_ASSET__DoS2VwyO__"